import jwtAuthAxios from "../auth/jwtAuth";

// «Descargas»: archivos que la plataforma genera en segundo plano (datos de un local, reportes en PDF). Los pedidos van
// sin alerta automática: los formularios muestran el error junto al campo.
const generatedFileServices = {};

generatedFileServices.list = async () => {
    const { data } = await jwtAuthAxios.get("/automations/generated_files");
    return data;
};

generatedFileServices.get = async (id) => {
    const { data } = await jwtAuthAxios.get(`/automations/generated_files/${id}`, { silentErrors: true });
    return data;
};

generatedFileServices.requestStoreData = async ({ store_id, from, to }) => {
    const { data } = await jwtAuthAxios.post("/automations/generated_files", { kind: "device_data", params: { store_id, from, to } }, { silentErrors: true });
    return data;
};

generatedFileServices.requestReport = async (reportType, params) => {
    const { data } = await jwtAuthAxios.post("/automations/generated_files", { kind: "report", report_type: reportType, params }, { silentErrors: true });
    return data;
};

// Baja el archivo con la sesión del usuario (la URL del archivo no es pública) y lo guarda con su nombre.
generatedFileServices.download = async (file) => {
    const { data } = await jwtAuthAxios.get(`/automations/generated_files/${file.id}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = url;
    link.download = file.filename || "descarga";
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};

const POLL_MS = 1500;
const MAX_POLLS = 120;
const sleep = (ms) => new Promise((resolve) => { setTimeout(resolve, ms); });

// Espera a que un archivo que se genera en segundo plano (un reporte en PDF) esté listo.
export const waitUntilReady = async (id) => {
    for (let attempt = 0; attempt < MAX_POLLS; attempt += 1) {
        await sleep(POLL_MS); // eslint-disable-line no-await-in-loop
        const file = await generatedFileServices.get(id); // eslint-disable-line no-await-in-loop
        if (file.status === "ready") return file;
        if (file.status === "failed") throw new Error(file.error_message || "No se pudo generar el PDF.");
    }
    throw new Error("El PDF está tardando más de lo normal. Cuando esté listo lo encontrarás en Descargas.");
};

export const requestErrors = (error, fallback) => {
    const errors = error?.response?.data?.errors;
    if (Array.isArray(errors) && errors.length) return errors.join(". ");
    return error?.response?.data?.error || fallback;
};

export default generatedFileServices;
